import { ReactNode } from "react";
import { Box, Card, Chip, Skeleton, Typography } from "@mui/material";
import { colors, radius } from "../../data/tokens";

type StatCardProps = {
  title: string;
  value: number | null; // null = carregando
  icon: ReactNode;
  subtitle?: string;
  // Sufixo colado ao número (ex.: "%" no cartão de adimplência)
  suffix?: string;
  // Variação percentual vs período anterior (ex.: novos sócios no mês)
  delta?: { percent: number; label: string } | null;
  // Valor em R$ (ex.: receita do semestre) — formata como moeda, sem centavos
  money?: boolean;
};

export function StatCard({
  title,
  value,
  icon,
  subtitle,
  suffix,
  delta,
  money,
}: StatCardProps) {
  const loading = value === null;
  return (
    <Card sx={{ height: "100%", p: 2.5, borderRadius: `${radius.lg}px` }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <Box>
          <Typography variant="body2" color="text.secondary">
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="caption" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Box>
        <Box
          sx={{
            backgroundColor: colors.bgContent,
            borderRadius: "8px",
            p: 0.75,
            display: "flex",
          }}
        >
          {icon}
        </Box>
      </Box>
      {loading ? (
        <Skeleton variant="text" width={90} sx={{ fontSize: "2rem", mt: 1 }} />
      ) : (
        <Typography
          variant="h4"
          sx={{ fontWeight: 700, color: colors.primaryDark, mt: 1 }}
        >
          {money
            ? value.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
                maximumFractionDigits: 0,
              })
            : value.toLocaleString("pt-BR")}
          {suffix ?? ""}
        </Typography>
      )}
      {!loading && delta && (
        <Box sx={{ mt: 1, display: "flex", alignItems: "center", gap: 1 }}>
          <Chip
            size="small"
            color={delta.percent >= 0 ? "success" : "error"}
            label={`${delta.percent >= 0 ? "↑" : "↓"} ${Math.abs(
              delta.percent
            ).toLocaleString("pt-BR", { maximumFractionDigits: 0 })}%`}
          />
          <Typography variant="caption" color="text.secondary">
            {delta.label}
          </Typography>
        </Box>
      )}
    </Card>
  );
}
